/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 14:23:56
 * @LastEditTime: 2020-11-23 10:40:00
 * @FilePath: \ensurance-front\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'
Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default

  return modules
}, {})

export default new Vuex.Store({
  getters,
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js